<template>
<div class="conatiner">
    <!-- <header class="header clearfix"> -->
      <el-row :gutter="20" style="margin-right:0;margin-left:0;position:absolute;z-index:300;background:#535353;width:100%">
        <el-col :span="4" style="padding-left:30px">
          <div class="logo fl">
            <embed :src="logo" class="logo-svg" />
          </div>
        </el-col>
        <el-col :span="16" style="text-align:center">
          <ul class="breadcrum" style="display:inline-block">
            <li v-for="item in breadcrumData" :class="{'li-active':item.type===active}" :key="item.type" @click="breadcrumClick(item.type)">
                <span :class="['iconfont',item.icon]" ></span>
                <strong>{{item.text}}</strong>
            </li>
          </ul>
        </el-col>
        <el-col :span="4" style="height:48px;line-height:48px;text-align:center">
          <el-dropdown trigger="click">
            <span class="el-dropdown-link">
                {{ userName }}<i class="iconfont icon-icon21" style="fontSize:10px;marginLeft:12px"></i>
            </span>
					  <el-dropdown-menu slot="dropdown" class="dropdown-menu" style="width:120px"> 
			        <el-dropdown-item v-if="role=='1'"><a href="javascript:;" @click="showDialogProfile = true"><i class="icon icon-user "></i>我的主页</a></el-dropdown-item>
			        <el-dropdown-item v-if="role=='1'"><a href="javascript:;" @click="showMoniRole = true"><i class="icon icon-Monitor iconfont" style="margin-top:-10px"></i>监控权限</a></el-dropdown-item>
              <el-dropdown-item><a href="javascript:;" @click="apiDilog = true"><i class="icon el-icon-tickets" style="margin-top:4px"></i>API认证</a></el-dropdown-item>
			        <el-dropdown-item><a href="javascript:;" @click="logoutHandler"><i class="icon icon-layout "></i>退出登录 </a></el-dropdown-item>
            </el-dropdown-menu>
				  </el-dropdown>
        </el-col>
      </el-row>
      
      <el-dialog title="监控权限" :visible.sync="showMoniRole">
        <el-form ref="formMoniRole" :model="moniRole" :rules="rulesMoniPwd" class="tab-modify-pwd">
          <el-form-item class="el-form-item-err" label="监控权限密码" label-width="120px" prop="new">
            <el-input type="password" v-model="moniRole.new" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item class="el-form-item-err" label="确认密码" label-width="120px" prop="newConfirm">
            <el-input type="password" v-model="moniRole.newConfirm" auto-complete="off"></el-input>
          </el-form-item>
        </el-form>
        <div class="tab-bott">
          <el-button @click="showMoniRole = false">取消</el-button>
          <el-button type="primary" class="btn-save-profile" @click="saveMoniRole('formMoniRole')">保存</el-button>
        </div>
      </el-dialog>
        <!-- <div class="fr user-operate"> -->
				<!-- personal info dialog start -->
				<el-dialog title="个人信息" :visible.sync="showDialogProfile">
					<el-tabs v-model="activeName" @tab-click="handleClick">
						<el-tab-pane label="基本信息" name="first">
						  <el-form ref="formEditProfileInfo" :model="profile.info" :rules="rulesProfileBase">
						  	<el-form-item label="邮箱账号" :label-width="formLabelWidth">
						  		<span>{{ email }}</span>
						  	</el-form-item>
						  	<el-form-item label="用户名/昵称" :label-width="formLabelWidth" prop="userName">
						  		<el-input v-model="profile.info.userName" auto-complete="off"></el-input>
						  	</el-form-item>
						  </el-form>
						  <div class="tab-bott">
						    <el-button @click="showDialogProfile = false">取消</el-button>
						    <el-button type="primary" class="btn-save-profile" @click="saveProfileBaseHandler('formEditProfileInfo')">保存</el-button>
						  </div>
						</el-tab-pane>
						<el-tab-pane label="修改密码" name="second">
							<el-form ref="formEditProfilePwd" :model="profile.pwd" :rules="rulesProfilePwd" class="tab-modify-pwd">
						    <el-form-item label="旧密码" :label-width="formLabelWidth" prop="old">
						      <el-input type="password" v-model="profile.pwd.old" auto-complete="off"></el-input>
						      <!-- <span class="error-info" v-if="showErrorPwdOld">旧密码输入错误</span> -->
						    </el-form-item>
						    <el-form-item class="el-form-item-err" label="新密码" :label-width="formLabelWidth" prop="new">
						      <el-input type="password" v-model="profile.pwd.new" auto-complete="off"></el-input>
						    </el-form-item>
						    <el-form-item class="el-form-item-err" label="确认密码" :label-width="formLabelWidth" prop="newConfirm">
						      <el-input type="password" v-model="profile.pwd.newConfirm" auto-complete="off"></el-input>
						    </el-form-item>
						  </el-form>
						  <div class="tab-bott">
						    <el-button @click="showDialogProfile = false">取消</el-button>
						    <el-button type="primary" class="btn-save-profile" @click="saveProfilePwdHandler('formEditProfilePwd')">保存</el-button>
						  </div>
						</el-tab-pane>
					</el-tabs>
				</el-dialog>
        <!-- </div> -->
  <!-- </header> -->

        <el-dialog
        title="API认证信息管理"
        :visible.sync="apiDilog" class="api-secret-dialog"
        width="600px">
        <div class="border"></div>
         <el-form ref="formData1"  :rules="rules"  class="el--jtk-suite-form-item" label-position="right" :model="node" label-width="150px">
          <el-form-item label="API Access ID">
             <div style="width:400px; overflow-x:auto;overflow-y:hidden" class="el-input__inner">{{node.appKey}}</div>
          </el-form-item>
           <el-form-item label="API Access Secret">
             <div style="width:400px;overflow-x:auto;overflow-y:hidden" class="el-input__inner">{{node.secretKey}}</div>
             <div v-if="tipWarn" style="color:#E97A2F">生成新的API认证信息后，之前的会作废，继续？</div>
          </el-form-item>
           <el-form-item >
              <el-button type="primary" :style="buttonStyle" @click="createSecret" v-if="!reset">生成</el-button>
              <div v-if="tipWarn">
                  <el-button :style="buttonStyle" @click="tipWarn=false">取消</el-button>
                <el-button :style="buttonStyle" type="primary" @click="createSecret">确认</el-button>
              </div>
               <el-button :style="buttonStyle" v-if="reset && !tipWarn" type="primary" @click="tipWarn=true">重新生成</el-button>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
         
          <el-button :style="buttonStyle" @click="apiDilog = false">关闭</el-button>
        </span>
      </el-dialog>

</div>
</template>
<script>
import logo from "@/images/logo.svg";
import request from "../../utils/request";
import api from "../../utils/http";
import utils from "../../utils/utils";
import { psdChangeMixin } from "../../utils/passwordChangeMixin";
import { VERSION } from "../../pages/flow/config.js";
export default {
  name: "appHeader",
  data() {
    var validateUserName = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("请输入用户名或昵称"));
      } else if (!/^[a-zA-Z0-9_\u4E00-\u9FA5]{2,16}$/.test(value)) {
        callback(new Error("用户名格式错误"));
      } else {
        callback();
      }
    };

    var validatePwdOld = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (
        !/^.*(?=.{6,})(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*? ]).*$/.test(
          value
        )
      ) {
        callback(
          new Error("密码至少包含1个大小写字母数字特殊字符,长度至少6位")
        );
      } else {
        callback();
      }
    };

    var validatePwdNew = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (
        !/^.*(?=.{6,})(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*? ]).*$/.test(
          value
        )
      ) {
        callback(
          new Error("密码至少包含1个大小写字母数字特殊字符,长度至少6位")
        );
      } else {
        callback();
      }
    };

    var validateCheckPwdNew = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (
        !/^.*(?=.{6,})(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*? ]).*$/.test(
          value
        )
      ) {
        callback(
          new Error("密码至少包含1个大小写字母数字特殊字符,长度至少6位")
        );
      } else if (value !== this.profile.pwd.new) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    var validateCheckMoniNew = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (
        !/^.*(?=.{6,})(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*? ]).*$/.test(
          value
        )
      ) {
        callback(
          new Error("密码至少包含1个大小写字母数字特殊字符,长度至少6位")
        );
      } else if (value !== this.moniRole.new) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };

    return {
      showMoniRole: false, //监控权限弹框
      role: "1", //用户角色,1：用户2:监控
      breadcrumData: [
        {
          text: "集成任务",
          icon: "icon-integration-job icon-color",
          type: "job"
        },
        { text: "监控台", icon: "icon-Monitor icon-color", type: "monitor" }
        // { text: "报表", icon: "icon-report icon-color", type: "report" }
      ],
      logo,
      apiDilog: false,
      rules: {},
      node: {},
      reset: false,
      tipWarn: false,
      buttonStyle: "padding:8px 16px",
      active: "",
      showDialogProfile: false,
      activeName: "first",
      menuIsShow: false,
      userName: "",
      email: "",
      profile: {
        info: {
          userName: ""
        },
        pwd: {
          old: "",
          new: "",
          newConfirm: ""
        }
      },
      moniRole: {
        new: "",
        newConfirm: ""
      },
      rulesMoniPwd: {
        new: [{ validator: validatePwdNew, trigger: "blur" }],
        newConfirm: [{ validator: validateCheckMoniNew, trigger: "blur" }]
      },
      rulesProfileBase: {
        userName: [{ validator: validateUserName, trigger: "blur" }]
      },
      rulesProfilePwd: {
        old: [{ validator: validatePwdOld, trigger: "blur" }],
        new: [{ validator: validatePwdNew, trigger: "blur" }],
        newConfirm: [{ validator: validateCheckPwdNew, trigger: "blur" }]
      },
      formLabelWidth: "100px",
      showErrorPwdOld: false
    };
  },
  props: ["activeType"],
  mixins: [psdChangeMixin],
  created() {
    this.active = this.activeType;
    this.queryApi();
    this.queryRule();
    let role = localStorage.getItem("userRole");
    if (role == "2") {
      this.role = "2";
      // this.active = "monitor";
      this.breadcrumData = [
        { text: "监控台", icon: "icon-Monitor icon-color", type: "monitor" }
      ];
    }
  },
  mounted() {
    this.dataInit();
  },
  methods: {
    dataInit() {
      let userName = sessionStorage.getItem("userName");

      if (userName) {
        this.userName = userName;
        this.profile.info.userName = userName;
      }

      this.email = sessionStorage.getItem("email");
    },
    async queryApi() {
      //查询API

      const res = await request({
        data: {
          header: {
            serviceCode: "API_AUTHORIZATION",
            method: "getAppKey"
          },
          body: {}
        },
        notLoading: true
      });
      if (res.data.header.returnCode === "000000") {
        this.reset = res.data.body.data;
        this.node = res.data.body.data || {};
      }
    },
    async queryRule() {
      //获取密码校验规则

      //console.log(reg)
      const { regs, length, msg } = await this.createRules({
        email: sessionStorage.getItem("email")
      });

      var validatePwdNew = (rule, value, callback) => {
        if (value === "") {
          callback(new Error("请再次输入密码"));
        } else if (!regs.test(value)) {
          callback(new Error("密码由" + msg.join("") + "组成" + length + "位"));
        } else if (value !== this.profile.pwd.new) {
          callback(new Error("两次输入密码不一致!"));
        } else {
          callback();
        }
      };
      var validateMoniNew = (rule, value, callback) => {
        if (value === "") {
          callback(new Error("请输入密码"));
        } else if (!regs.test(value)) {
          callback(new Error("密码由" + msg.join("") + "组成" + length + "位"));
        } else if (value !== this.moniRole.new) {
          callback(new Error("两次输入密码不一致!"));
        } else {
          callback();
        }
      };
      this.rulesProfilePwd = {
        old: [{ required: true, trigger: "blur", message: "密码不能为空" }],
        new: [{ validator: validatePwdNew, trigger: "blur" }],
        newConfirm: [{ validator: validatePwdNew, trigger: "blur" }]
      };
      this.rulesMoniPwd = {
        new: [{ validator: validateMoniNew, trigger: "blur" }],
        newConfirm: [{ validator: validateMoniNew, trigger: "blur" }]
      };
    },

    toggleMenu() {
      this.menuIsShow = !this.menuIsShow;
    },
    hideMenu() {
      this.menuIsShow = false;
    },
    async createSecret() {
      //生产秘yao
      const res = await request({
        data: {
          header: {
            serviceCode: "API_AUTHORIZATION",
            method: "createAppKey"
          },
          body: {}
        }
      });
      if (res.data.header.returnCode === "000000") {
        this.node = res.data.body.data;
        this.reset = true;
        this.tipWarn = false;
      } else {
        this.$message.error("生成失败");
      }
    },
    breadcrumClick(type) {
      //面包屑点击事件
      switch (type) {
        case "job":
          this.$router.push("/");
          break;
        case "monitor":
          this.$router.push("/monitor");
          break;
        case "report":
          break;
        default:
          break;
      }
      this.active = type;
    },
    async logoutHandler() {
      const response = await request({
        url: "/symphony-design/execute?serviceCode=logout",
        data: {
          header: {
            serviceCode: "LOGOUT"
          },
          body: {}
        }
      });
      if (response.data.header.returnCode == "000000") {
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("userName");
        localStorage.removeItem("cloneData");
        this.$router.push({ path: "/account/login" });
      }
    },

    handleClick(tab, event) {
      //console.log(tab, event);
    },

    tabInit() {
      this.activeName = "first";
      this.profile.pwd.old = "";
      this.profile.pwd.new = "";
      this.profile.pwd.newConfirm = "";
    },
    async saveMoniRole(formName) {
      let flag = false;
      this.$refs[formName].validate(valid => {
        if (valid) {
          flag = true;
        } else {
          return false;
        }
      });
      if (flag) {
        const res = await request({
          data: {
            header: {
              serviceCode: "MEMBER_ADD_PASSWORD",
              method: "addPassword"
            },
            body: {
              mPassword: this.moniRole.new
            }
          },
          notLoading: true
        });
        if (res.data.header.returnCode === "000000") {
          this.$message.success("添加成功");
          this.showMoniRole = false;
        } else {
          this.$message.error(res.data.header.msg);
        }
      }
    },
    saveProfileBaseHandler(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          api.post(
            "/symphony-design/execute?serviceCode=modifyUserName",
            {
              header: {
                serviceCode: "PROFILE"
              },
              body: {
                method: "updateName",
                name: this.profile.info.userName,
                email: sessionStorage.getItem("email")
              }
            },
            response => {
              let errorMsg = utils.checkReturnCode(
                response,
                "基本信息保存错误"
              );
              if (errorMsg) {
                this.$message.error(errorMsg);
              } else {
                if (response.data.header.returnCode == "000000") {
                  setTimeout(() => {
                    this.showDialogProfile = false;
                    this.$message({
                      type: "success",
                      message: "修改成功"
                    });
                    this.userName = this.profile.info.userName;
                    sessionStorage.setItem(
                      "userName",
                      this.profile.info.userName
                    );
                  }, 2000);
                }
              }
            }
          );
        } else {
          return false;
        }
      });
    },

    async saveProfilePwdHandler(formName) {
      let flag = false;
      this.$refs[formName].validate(valid => {
        if (valid) {
          flag = true;
        } else {
          return false;
        }
      });
      if (flag) {
        const { code } = await this.resetPassword({
          email: sessionStorage.getItem("email"),
          oldPassword: this.profile.pwd.old,
          newPassword: this.profile.pwd.new
        });
        if (code === "000000") {
          this.showDialogProfile = false;
          this.$message({
            type: "success",
            message: "修改成功"
          });
          this.tabInit();
        }
      }
    }
  }
};
</script>
<style lang="less" scoped>
.icon {
  display: inline-block;
  vertical-align: middle;
  width: 16px;
  height: 16px;
  background-repeat: no-repeat;
  background-position: center;
}

.icon-user {
  background-image: url(../../images/icons/icon_user.png);
}

.icon-layout {
  background-image: url(../../images/icons/icon_layout.png);
}
.conatiner {
  width: 100%;
  background: rgba(83, 83, 83, 1);
  min-width: 1170px;
}
.header {
  width: 1130px;
  height: 48px;
  padding: 0px 20px;
  margin: 0px auto;
}

.logo {
  width: 320px;
}
.logo-svg {
  display: block;
  width: 240px;
  height: 28px;
  margin-top: 10px;
}
.breadcrum {
  // width: 720px;
  font-size: 16px;
  color: rgba(230, 230, 230, 1);
  > li {
    width: 240px;
    float: left;
    text-align: center;
    line-height: 48px;
    cursor: pointer;
  }
  > li:hover {
    background-color: #343434;
  }
  > .li-active {
    background-color: #343434;
  }
}

.icon-color {
  color: #00bdff;
  margin-right: 8px;
}
.user-operate {
  position: relative;
  cursor: pointer;
  margin-top: 16px;
}
.el-dropdown-link {
  font-size: 16px;
  color: rgba(230, 230, 230, 1);
  font-weight: normal;
}
.dropdown-menu {
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  a {
    display: block;
    width: 100%;
    height: 26px;
    line-height: 26px;
    color: #333;
    box-sizing: border-box;
    &:hover {
      color: #09c;
      .icon-user {
        background-image: url(../../images/icons/icon_user_on.png);
      }
      .icon-layout {
        background-image: url(../../images/icons/icon_layout_on.png);
      }
    }
  }

  i {
    margin-right: 6px;
  }
}

.user-info {
  display: block;
  span,
  i {
    display: inline-block;
    margin-left: 4px;
    vertical-align: middle;
  }
  .user-avatar {
    width: 25px;
    height: 25px;
    line-height: 27px;
    text-align: center;
    background: #b95bef;
    font-size: 12px;
    color: #fff;
    border-radius: 50%;
    opacity: 0.4;
    filter: alpha(opacity=40);
  }
  .user-name {
    line-height: 48px;
    color: #777;
  }
  .icon-caret {
    margin-top: 6px;
    width: 0;
    height: 0;
    border-style: solid dashed dashed;
    border-width: 4px;
    border-color: #777 transparent transparent;
  }
}

.el-tabs__active-bar {
  background: #005ff2;
}

.el-tabs__item.is-active {
  color: #005ff2;
}

.tab-bott {
  text-align: right !important;
}

.btn-save-profile {
  background-color: #005ff2;
  border-color: #005ff2;
}

.error-field {
  .el-input__inner {
    border: 1px solid #f00;
  }
}

.error-info {
  position: absolute;
  top: 36px;
  left: 0;
  line-height: 20px;
  font-size: 12px;
  color: #f00;
}

.tab-modify-pwd {
  width: 420px !important;
}
.border {
  height: 1px;
  border-top: 1px solid #ddd;
  margin: -25px -20px 40px -20px;
}
</style>



// WEBPACK FOOTER //
// headNew.vue?6f35df2a